import { AlertMessage, MUIIcon, Spinner } from "../../../../widgets"
import { FC, useState } from "react"

import { IPaymentButtonProps } from "../IPaymentButtonProps"
import { PageLinkHelper } from "../../../../base/helpers"
import clsx from "clsx"
import { getButtonClass } from "../../buttons/helper"
import { submitForm } from "../../../helpers/submit-form"
import { toAbsoluteUrl } from "../../../../../helpers"
import { useAuth } from "../../../../../modules/auth"
import { useGetAMHashMutation } from "./services"

export const AMBankButton: FC<IPaymentButtonProps> = ({
    orderNo, enrolmentNo, entity, entityId, amount,
    firstName, lastName, email, phoneNumber,
    successPage, failedPage, disabled, tooltip,
    style, size, icon, className, label, children
}) => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
    const [error, setError] = useState<string>()

    const { siteId } = useAuth()
    const [getHash] = useGetAMHashMutation()

    const handleOnClick = () => {
        if (!siteId || !orderNo || !amount || !successPage || !failedPage) return;
        setIsSubmitting(true)
        setError('')

        const successPageUrl = PageLinkHelper.getPageLinkUrl(siteId, successPage);
        const failedPageUrl = PageLinkHelper.getPageLinkUrl(siteId, failedPage);

        getHash({
            orderNo,
            enrolmentNo,
            entity,
            entityId,
            amount,
            firstName,
            lastName,
            email,
            phoneNumber,
            successPageUrl,
            failedPageUrl
        })
            .unwrap()
            .then(data => {
                submitForm(data.url, data.formData, "post")
            })
            .catch(() => {
                setError('Failed to generate payment request.');
                setIsSubmitting(false)
            })
            .finally()
    }

    return (
        <>
            <button
                disabled={disabled === true || isSubmitting === true || !orderNo || !amount}
                type="button"
                title={tooltip}
                onClick={handleOnClick}
                className={clsx(getButtonClass(style, size, "btn-secondary"), className)}
            >
                <Spinner show={isSubmitting} className="me-1" />
                <img
                    alt='img'
                    className='h-28px w-80px'
                    src={toAbsoluteUrl('/media/logos/ambankLogo2.png')}
                />

                {(!isSubmitting && icon) && <MUIIcon iconName={icon} className={clsx({ "me-1": !!label })} />}
                {label && <span>{label}</span>}
                {children}
            </button>
            <AlertMessage type="Error" show={!!error} message={error} />
        </>
    )

}